module.exports = __webpack_public_path__ + "static/media/md-pricetag.2db7c006.svg";